// This imports a huge file, we can just take out the icons we need
// at some point in the future. Or see if we can do so with webpack
// Find icons at: https://materialdesignicons.com/
import * as icons from '@mdi/js'

/**
 * mapping icon options to (MDI) Icons.
 */

export type IconOption =
    'question' |
    'bookmark' |
    'send' |
    'message' |
    'remove' |
    'messageProcessing' |
    'user' |
    'zoom' |
    'settings' |
    'left' |
    'right' |
    'exit' |
    'add' |
    'video' |
    'videoOff' |
    'mic' |
    'micOff' |
    'close' |
    'savedBookmark' |
    'search' |
    'info'|
    'personCircle'|
    'groupCircle' |
    'menu' |
    'check' |
    'dotsVertical' |
    'cardAccountDetailsOutline' |
    'forum' |
    'calendarClock' |
    'alertDecagram' |
    'file' |
    'enter' |
    'youtube' |
    'linkedIn' |
    'facebook' |
    'twitter' |
    'instagram' |
    'pencil' |
    'leftDropCircle' |
    'rightDropCircle' |
    'monitorEye' |
    'alert' |
    'download' |
    'chevronDown'|
    'calendarRange' |
    'clock' |
    'mapMarker' |
    'goodiebag' |
    'map' |
    'group' |
    'fullscreen' |
    'fullscreenExit' |
    'filepowerpoint' |
    'fileword' |
    'filepdf' |
    'fileimage' |
    'eye' |
    'gamepad' |
    'arrowExpand' |
    'infoOutline' |
    'volumeOff' |
    'delete' |
    'refresh' |
    'doorOpen'|
    'monitorShare'|
    'monitorOff'|
    'stop'|
    'textBox'|
    'email' |
    'openInNew';

export const iconPaths: Record<IconOption, string> = {
    question: icons.mdiHelpCircle,
    info: icons.mdiInformation,
    close: icons.mdiClose,
    send: icons.mdiSend,
    search: icons.mdiMagnify,
    zoom: icons.mdiMagnify,
    add: icons.mdiPlus,
    remove: icons.mdiMinus,
    message: icons.mdiMessage,
    left: icons.mdiChevronLeft,
    right: icons.mdiChevronRight,
    video: icons.mdiVideo,
    videoOff: icons.mdiVideoOff,
    settings: icons.mdiCog,
    bookmark: icons.mdiBookmark,
    savedBookmark: icons.mdiBookmarkCheck,
    user: icons.mdiAccount,
    exit: icons.mdiLocationExit,
    mic: icons.mdiMicrophone,
    micOff: icons.mdiMicrophoneOff,
    messageProcessing: icons.mdiMessageProcessing,
    personCircle: icons.mdiAccountCircle,
    groupCircle: icons.mdiAccountSupervisorCircle,
    check: icons.mdiCheck,
    menu: icons.mdiHamburger,
    enter: icons.mdiLocationEnter,
    dotsVertical: icons.mdiDotsVertical,
    cardAccountDetailsOutline: icons.mdiCardAccountDetailsOutline,
    forum: icons.mdiForum,
    calendarClock: icons.mdiCalendarClock,
    alertDecagram: icons.mdiAlertDecagram,
    file: icons.mdiFile,
    youtube: icons.mdiYoutube,
    linkedIn: icons.mdiLinkedin,
    facebook: icons.mdiFacebook,
    twitter: icons.mdiTwitter,
    instagram: icons.mdiInstagram,
    pencil: icons.mdiPencil,
    leftDropCircle: icons.mdiArrowLeftDropCircle,
    rightDropCircle: icons.mdiArrowRightDropCircle,
    monitorEye: icons.mdiMonitorEye,
    alert: icons.mdiAlert,
    download: icons.mdiDownload,
    chevronDown: icons.mdiChevronDown,
    calendarRange: icons.mdiCalendarRange,
    clock: icons.mdiClockOutline,
    mapMarker: icons.mdiMapMarker,
    goodiebag: icons.mdiBagChecked,
    map: icons.mdiMap,
    group: icons.mdiAccountGroup,
    fullscreen: icons.mdiFullscreen,
    fullscreenExit: icons.mdiFullscreenExit,
    filepowerpoint: icons.mdiFilePowerpoint,
    fileword: icons.mdiFileWord,
    filepdf: icons.mdiPdfBox,
    fileimage: icons.mdiFileImage,
    eye: icons.mdiEye,
    gamepad: icons.mdiGamepadVariant,
    arrowExpand: icons.mdiArrowExpandAll,
    infoOutline: icons.mdiInformationOutline,
    volumeOff: icons.mdiVolumeOff,
    delete: icons.mdiDelete,
    refresh: icons.mdiRefresh,
    doorOpen: icons.mdiDoorOpen,
    monitorShare: icons.mdiMonitorShare,
    monitorOff: icons.mdiMonitorOff,
    stop: icons.mdiStopCircle,
    textBox: icons.mdiTextBox,
    email: icons.mdiEmail,
    openInNew: icons.mdiOpenInNew,
}
